// // api/askAhaMomentAI.js
 import axios from 'axios';

export const askAhaMomentAI = async ({ userId, chatsessionid, usermessage, messageCount = 0 }) => {
  try {
    const response = await axios.post(
      'https://mcp-server-fintorro.onrender.com/ahaMomentAiChat',
      {
        userid: userId,
        chatsessionid,
        usermessage,
        messageCount,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-aimodel': 'openai',
        },
      }
    );

    return response.data.airesponse || '⚠️ AI response unavailable.';
  } catch (err) {
    console.error('❌ Error in askAhaMomentAI:', err);
    return '⚠️ Something went wrong. Please try again later.';
  }
}




// 💡 Added enhancements:
// - This module will be reused across AI onboarding chat components.
// - Handles headers and fallback messaging for all aha moment queries.
